import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { MessageService } from 'primeng/api';
import { GenericService } from 'src/app/services/generic.service';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

@Component({
  selector: 'app-porspect-info',
  templateUrl: './prospect-info.component.html',
  styleUrls: ['./prospect-info.component.css']
})
export class ProspectInfoComponent implements OnInit {

  form: any | FormGroup
  modelSubtitle = false
  checked = false
  name = ""
  version = ""
  isActive = false
  data: any =[];
  prospectdata: any = [];

  cid:any
  usersWithoutCustomers:any = [];
  prospectStatus:any = "All"

  statusList: any = [
    "All",
    "REQUESTED",
    "VERIFIED",
    "APPROVED",
    "REJECTED",
    "ASSIGNED"
  ];
  isOtpClicked: any = false
  otp: any
  first: number = 0;
  isLoading: any = false

  pageNumber: number = 0;
  pageNumber1: number = 0;
  totalRecords: number = 0;
  recordsPerPage:number = 10;
  showFilter: any = false

  selectedFilter: any = ""

  phoneChecked = false;
  phoneFilter = "";

  emailChecked = false;
  emailFilter = "";


  actionControls: any = {
    isAdd: false, 
    isView: false, 
    isDelete: false, 
    isModify: false 
  }
  searchFilter: string = "";

  constructor(private fb: FormBuilder,
    private toastr: ToastrService,private messageService: MessageService,
    private generic_service: GenericService) { }

  ngOnInit(): void {


  let href:any = window.location.href;
  let messages = href.split('/') 
  let action: any = this.generic_service.checkActionControls(messages[messages.length-1])
  this.actionControls = action

    this.cid = sessionStorage.getItem('cid')
    this.getProspect(this.prospectStatus)
    this.form = this.fb.group({
      prospectRegistrationId: [''],
      userId: ['']
    })  
    this.getUsersWithoutCustomers()
  }

  cancelModel(){
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton1")?.click()
    document.getElementById("closeModalButton3")?.click()
  }

  toggleFilter(){
    this.showFilter = !this.showFilter
  }

  onTableDataChange(event: any) {
    this.pageNumber = event.page;
    this.pageNumber1 = event.page;
    this.getProspect(this.prospectStatus)
  }


  // onTableDataChange(event: any) {
  //   this.pageNumber = event.page;
  //   this.pageNumber1 = event.page;

  //   if(this.searchFilter != ""){
  //     this.getAllProspectRegistrationWildSearchWithPagination(this.pageNumber,this.recordsPerPage)
  //   }else{
  //     this.getAllProspectRegistrationWithPagination(this.pageNumber,this.recordsPerPage)
  //   }
  // }

  applyFilter() {
    if (this.phoneChecked) {
      this.showPhoneOtp(this.phoneFilter);
    }

    if (this.emailChecked) {
      this.showEmailOtp(this.emailFilter);
    }
  }

  onFilterSelect(selected: string) {
    console.log(selected)
  
    this.phoneChecked = false
    this.emailChecked = false
    this.selectedFilter = selected

    

    if(selected == "phoneFilter"){
      this.phoneChecked = true
    }

    if(selected == "emailFilter"){
      this.emailChecked = true
    }

  }

  resetFilter(){
    this.pageNumber = 0
    this.first = 0
    this.searchFilter = ""
    this.phoneChecked = false
    this.emailChecked = false
    this.phoneFilter = ""
    this.emailFilter = ""
    this.selectedFilter = ""
    this.getAllProspectRegistrationWithPagination(this.pageNumber,this.recordsPerPage)
  }

  refreshAll(){
    this.pageNumber = 0
    this.first = 0
    this.searchFilter = ""
    this.showFilter = false
    this.getAllProspectRegistrationWithPagination(this.pageNumber,this.recordsPerPage)

  }

  getAllProspectRegistrationWildSearchWithPagination(pageNumber: any,recordsPerPage: any){
   if(this.searchFilter == "" || this.searchFilter == null){
      return
    }

    this.isLoading = true

    this.generic_service.getAllProspectRegistrationWildSearchWithPagination(this.searchFilter,pageNumber,recordsPerPage).subscribe(
      (response:any)=>{
        for(let list of response.response.prospectRegistrationList){
          let applicationFormFor: any = ""
          let fatherHusbandName: any = ""
          let noOfCableConnection: any = ""
          let noOfInternetConnection: any = ""
          let identityProofType: any = ""
          let termsOfPayment: any = ""
          let bookedBy: any = ""
          let agentName: any = ""
          let identityProofAttachmentURL: any = ""
          let customerId: any = ""

          if(list.keyValuePairs != null){
            for(let key of list.keyValuePairs){
              if(key.key == "Application Form For"){
                applicationFormFor = key.value
              }

              if(key.key == "Father/Husband Name"){
                fatherHusbandName = key.value
              }

              if(key.key == "No Of Cable Connection"){
                noOfCableConnection = key.value
              }

              if(key.key == "No Of Internet Connection"){
                noOfInternetConnection = key.value
              }

              if(key.key == "Identity Proof Type"){
                identityProofType = key.value
              }

              if(key.key == "Terms Of Payment"){
                termsOfPayment = key.value
              }

              if(key.key == "Booked By"){
                bookedBy = key.value
              }

              if(key.key == "Agent Name"){
                agentName = key.value
              }

              if(key.key == "Identity Proof AttachmentURL"){
                identityProofAttachmentURL = key.value
              }

              if(key.key == "customerId"){
                customerId = key.value
              }
            }
          }

          list.applicationFormFor = applicationFormFor
          list.fatherHusbandName = fatherHusbandName
          list.noOfCableConnection = noOfCableConnection
          list.noOfInternetConnection = noOfInternetConnection
          list.identityProofType = identityProofType
          list.termsOfPayment = termsOfPayment
          list.bookedBy = bookedBy
          list.agentName = agentName
          list.identityProofAttachmentURL = identityProofAttachmentURL
          list.customerId = customerId
        }
        this.data = response.response.prospectRegistrationList;
        this.totalRecords = response.response.totalRecords;
        console.log(response)
        this.isLoading = false

      }
    )



  }


  getProspect(status:any){
    if(status == "All"){
      this.getAllProspectRegistrationWithPagination(this.pageNumber,this.recordsPerPage)
    }else{
      this.getByStatusWithPagination(status,this.pageNumber,this.recordsPerPage)
    }
  }

  getByProspectStatus(status:any){
    this.pageNumber = 0
    this.first = 1;

    if(status == "All"){
      this.getAllProspectRegistrationWithPagination(this.pageNumber,this.recordsPerPage)
    }else{
      this.getByStatusWithPagination(status,this.pageNumber,this.recordsPerPage)
    }
  }


  getAllProspectRegistrationWithPagination(pageNumber: any,recordsPerPage: any){
    this.isLoading = true

    this.generic_service.getAllProspectRegistrationWithPagination(pageNumber,recordsPerPage).subscribe(
      (response:any)=>{
        for(let list of response.response.prospectRegistrationList){
          let applicationFormFor: any = ""
          let fatherHusbandName: any = ""
          let noOfCableConnection: any = ""
          let noOfInternetConnection: any = ""
          let identityProofType: any = ""
          let termsOfPayment: any = ""
          let bookedBy: any = ""
          let agentName: any = ""
          let identityProofAttachmentURL: any = ""
          let customerId: any = ""

          if(list.keyValuePairs != null){
            for(let key of list.keyValuePairs){
              if(key.key == "Application Form For"){
                applicationFormFor = key.value
              }

              if(key.key == "Father/Husband Name"){
                fatherHusbandName = key.value
              }

              if(key.key == "No Of Cable Connection"){
                noOfCableConnection = key.value
              }

              if(key.key == "No Of Internet Connection"){
                noOfInternetConnection = key.value
              }

              if(key.key == "Identity Proof Type"){
                identityProofType = key.value
              }

              if(key.key == "Terms Of Payment"){
                termsOfPayment = key.value
              }

              if(key.key == "Booked By"){
                bookedBy = key.value
              }

              if(key.key == "Agent Name"){
                agentName = key.value
              }

              if(key.key == "Identity Proof AttachmentURL"){
                identityProofAttachmentURL = key.value
              }

              if(key.key == "customerId"){
                customerId = key.value
              }
            }
          }

          list.applicationFormFor = applicationFormFor
          list.fatherHusbandName = fatherHusbandName
          list.noOfCableConnection = noOfCableConnection
          list.noOfInternetConnection = noOfInternetConnection
          list.identityProofType = identityProofType
          list.termsOfPayment = termsOfPayment
          list.bookedBy = bookedBy
          list.agentName = agentName
          list.identityProofAttachmentURL = identityProofAttachmentURL
          list.customerId = customerId
        }
        this.data = response.response.prospectRegistrationList;
        this.totalRecords = response.response.totalRecords;
        console.log(response)
        this.isLoading = false

      }
    )
  }

  getByStatusWithPagination(status:any,pageNumber: any,recordsPerPage: any){
    this.isLoading = true

    this.generic_service.getByStatusWithPagination(status,pageNumber,recordsPerPage).subscribe(
      (response:any)=>{
        for(let list of response.response.prospectRegistrationList){
          let applicationFormFor: any = ""
          let fatherHusbandName: any = ""
          let noOfCableConnection: any = ""
          let noOfInternetConnection: any = ""
          let identityProofType: any = ""
          let termsOfPayment: any = ""
          let bookedBy: any = ""
          let agentName: any = ""
          let identityProofAttachmentURL: any = ""
          let customerId: any = ""

          if(list.keyValuePairs != null){
            for(let key of list.keyValuePairs){
              if(key.key == "Application Form For"){
                applicationFormFor = key.value
              }

              if(key.key == "Father/Husband Name"){
                fatherHusbandName = key.value
              }

              if(key.key == "No Of Cable Connection"){
                noOfCableConnection = key.value
              }

              if(key.key == "No Of Internet Connection"){
                noOfInternetConnection = key.value
              }

              if(key.key == "Identity Proof Type"){
                identityProofType = key.value
              }

              if(key.key == "Terms Of Payment"){
                termsOfPayment = key.value
              }

              if(key.key == "Booked By"){
                bookedBy = key.value
              }

              if(key.key == "Agent Name"){
                agentName = key.value
              }

              if(key.key == "Identity Proof AttachmentURL"){
                identityProofAttachmentURL = key.value
              }

              if(key.key == "customerId"){
                customerId = key.value
              }
            }
          }

          list.applicationFormFor = applicationFormFor
          list.fatherHusbandName = fatherHusbandName
          list.noOfCableConnection = noOfCableConnection
          list.noOfInternetConnection = noOfInternetConnection
          list.identityProofType = identityProofType
          list.termsOfPayment = termsOfPayment
          list.bookedBy = bookedBy
          list.agentName = agentName
          list.identityProofAttachmentURL = identityProofAttachmentURL
          list.customerId = customerId
        }
        this.data = response.response.prospectRegistrationList;
        this.totalRecords = response.response.totalRecords;
        console.log(response)
        this.isLoading = false
      }
    )
  }

  getProspectByID(id:any){
    this.generic_service.getProspectByID(id).subscribe(
      (res:any)=>{
        this.prospectdata = [];
        console.log(res);
       
        this.prospectdata.push(res.response);
        for(let list of this.prospectdata){
          let applicationFormFor: any = ""
          let fatherHusbandName: any = ""
          let noOfCableConnection: any = ""
          let noOfInternetConnection: any = ""
          let identityProofType: any = ""
          let termsOfPayment: any = ""
          let bookedBy: any = ""
          let agentName: any = ""
          let identityProofAttachmentURL: any = ""
          let customerId: any = ""

          if(list.keyValuePairs != null){
            for(let key of list.keyValuePairs){
              if(key.key == "Application Form For"){
                applicationFormFor = key.value
              }

              if(key.key == "Father/Husband Name"){
                fatherHusbandName = key.value
              }

              if(key.key == "No Of Cable Connection"){
                noOfCableConnection = key.value
              }

              if(key.key == "No Of Internet Connection"){
                noOfInternetConnection = key.value
              }

              if(key.key == "Identity Proof Type"){
                identityProofType = key.value
              }

              if(key.key == "Terms Of Payment"){
                termsOfPayment = key.value
              }

              if(key.key == "Booked By"){
                bookedBy = key.value
              }

              if(key.key == "Agent Name"){
                agentName = key.value
              }

              if(key.key == "Identity Proof AttachmentURL"){
                identityProofAttachmentURL = key.value
              }

              if(key.key == "customerId"){
                customerId = key.value
              }
            }
          }

          list.applicationFormFor = applicationFormFor
          list.fatherHusbandName = fatherHusbandName
          list.noOfCableConnection = noOfCableConnection
          list.noOfInternetConnection = noOfInternetConnection
          list.identityProofType = identityProofType
          list.termsOfPayment = termsOfPayment
          list.bookedBy = bookedBy
          list.agentName = agentName
          list.identityProofAttachmentURL = identityProofAttachmentURL
          list.customerId = customerId
        }
        this.form.setValue(
          {
            prospectRegistrationId: res.response.prospectRegistrationId,
            userId: ['']
          }
        );
      }
    )
  }

  getUsersWithoutCustomers(){
    this.generic_service.getUsersWithoutCustomers().subscribe(
      (res:any)=>{
        console.log(res);
        this.usersWithoutCustomers = res.response;
      }
    )
  }

  prospectAssignToUser(){
    let body = {
      "prospectRegistrationId": Number(this.form.get('prospectRegistrationId').value),
      "userId": Number(this.form.get('userId').value),
    }

    console.log(body)
    this.generic_service.prospectAssignToUser(body).subscribe(
      (response:any) => {
        console.log(response)
        this.cancelModel()
        this.toastr.success(response.response)

      },
      (error:any)=>{
        console.log(error)
      }
    )
  }

  sendOTP(){
    this.isOtpClicked = !this.isOtpClicked
    if(!this.isOtpClicked){
      this.otp = ""
    }
  }

  verifyOTP(){
    this.isOtpClicked = !this.isOtpClicked
    if(!this.isOtpClicked){
      this.otp = ""
    }
  }

  showPhoneOtp(phone: any){

    this.generic_service.showPhoneOtp(phone).subscribe(
      (response:any) => {
        console.log(response)
        let summary: any
        summary = "Phone Otp: " + response.response.phoneNoOtp
        this.showToaster(
          { severity: 'success', summary: summary,life: 20000 }
        )
  
      },
      (error:any)=>{
        this.showToaster(
          { severity: 'error', summary: error.message,life: 20000 }
        )
        console.log(error)
      }
    )



  }

  showEmailOtp(email: any){

    this.generic_service.showEmailOtp(email).subscribe(
      (response:any) => {
        console.log(response)
        let summary: any

        summary = "Email Otp: " + response.response.phoneNoOtp
        this.showToaster(
          { severity: 'success', summary: summary,life: 20000 }
        )
  
      },
      (error:any)=>{
        console.log(error)
        this.showToaster(
          { severity: 'error', summary: error.error.message,life: 20000 }
        )
      }
    )



  }

  printProspect() {
    let printContents = document.querySelector('.prospect-block')?.innerHTML;
    if (printContents) {
      let printWindow = window.open('', '', 'height=600,width=800');
      if (printWindow) {
        printWindow.document.write('<html><head><title>Print Prospect</title>');
        printWindow.document.write('<style>body{font-family: sans-serif;} .application-form, .applicant-form { margin-bottom: 15px; } .row { display: flex; flex-wrap: wrap; } .col-md-4, .col-lg-4 { width: 33.33%; padding: 5px; box-sizing: border-box; } .col-md-12 { width: 100%; } img { max-width: 100px; max-height: 100px; margin-right: 10px; } .proof-images, .feasibility-images { display: flex; gap: 10px; flex-wrap: wrap; } p { margin: 5px 0; font-weight: bold; } label { color: #666; font-size: 14px; } .modal-footer { display: none !important; }</style>');
        printWindow.document.write('</head><body>');
        printWindow.document.write(printContents);
        printWindow.document.write('</body></html>');
        printWindow.document.close();
        printWindow.focus();
        setTimeout(() => {
          if (printWindow) {
            printWindow.print();
            printWindow.close();
          }
        }, 500);
      }
    }
  }

  downloadProspect() {
    let element = document.querySelector('.prospect-block') as HTMLElement;
    let footer = element?.querySelector('.modal-footer') as HTMLElement;
    if (footer) footer.style.display = 'none';

    if (element) {
      html2canvas(element, { scale: 2, useCORS: true }).then((canvas) => {
        if (footer) footer.style.display = '';
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF('p', 'mm', 'a4');
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
        let position = 0;
        
        pdf.addImage(imgData, 'PNG', 0, position, pdfWidth, pdfHeight);
        pdf.save('prospect_info.pdf');
      }).catch(err => {
        if (footer) footer.style.display = '';
        console.error("Error generating PDF", err);
        this.showToaster({severity: 'error', summary: 'Failed to generate PDF'});
      });
    } else {
      if (footer) footer.style.display = '';
    }
  }

  showToaster(message: any) {
    this.messageService.add(message);
  }
}